import { useReducer } from 'react'

export default function useInputKey() {
  return useReducer(k => k + 1, 1)
}
